import { Component } from '@angular/core';

@Component({
  selector: 'app-no-license',
  templateUrl: './no-license.component.html',
  styleUrls: ['./no-license.component.css'],
})
export class NoLicenseComponent {
  show = true;
  constructor() { }
  toggle() {
    this.show = !this.show;
  }
}
